import React from 'react';
import { connect } from 'react-redux';
import * as productActions from './actions';
import { track } from 'shared/models/analytic';
import { trackInfo } from 'shared/models/product';
import HeadTags from './head';
import ProductInfo from './ProductInfo';
import RecommendationsCard from './RecommendationsCard';
import RatingsAndReviews from './RatingsAndReviews';
import { MediumContainer } from 'scy/layouts';
import Card from 'scy/Card';
import { Body } from 'scy/text';
import { capitalize } from 'shared/utils';
import { isEqual as sameAddress } from 'shared/models/address';
import AsyncLeadCaptureModal from 'components/leadCaptureModal/async';
import { tablet_hidden } from 'scy/display.mod.scss';
import styles from './styles.mod.scss';

class Product extends React.Component {
  loadProduct(sku) {
    this.props.getPrices(sku);
    this.props.getRelatedProducts(sku);
    this.props.loadRatings({ sku_id: sku });
    this.props.fetchProduct(sku).then(product => {
      this._trackView(product);
      this.props.getParentCategories();
    });
  }

  _skuFromRoute(props) {
    return props.match.params.sku;
  }

  _trackView(product) {
    track('Product Viewed', trackInfo(product));
  }

  componentDidMount() {
    /* navigate to product page, then non-product page,
     * then different product page */
    const oldSku = this.props.product.sku_id;
    const newSku = this._skuFromRoute(this.props);
    if (oldSku !== newSku) this.loadProduct(newSku);
    else this._trackView(this.props.product);
  }

  componentDidUpdate(prevProps) {
    if (!sameAddress(this.props.address, prevProps.address)) {
      this.loadProduct(this._skuFromRoute(this.props));
    }

    /* navigate from product page to different product page */
    const oldSku = this._skuFromRoute(prevProps);
    const newSku = this._skuFromRoute(this.props);
    if (oldSku !== newSku) this.loadProduct(newSku);
  }

  render() {
    const {
      product,
      productLoading,
      previewingProduct,
      moreByBrand,
      moreByBrandLoading,
      similarProducts,
      boughtWith,
      boughtWithLoading,
      parentCategories,
      ratings,
      ratingsLoading,
      user
    } = this.props;

    const category = product.category || {};
    const loading = productLoading && !previewingProduct;
    const brandName = capitalize(product.company || product.brand);

    const ratingValue = ratings && ratings.stats ? ratings.stats.average : null;
    const ratingCount = ratings && ratings.stats ? ratings.stats.count : null;

    return (
      <MediumContainer className={styles.container}>
        {!productLoading && (
          <HeadTags
            product={product}
            parentCategories={parentCategories}
            ratingValue={ratingValue}
            ratingCount={ratingCount}
          />
        )}

        <ProductInfo
          product={product}
          loading={loading}
          brandName={brandName}
          parentCategories={parentCategories}
          moreByBrand={moreByBrand}
          moreByBrandLoading={moreByBrandLoading}
          boughtWith={boughtWith}
          boughtWithLoading={boughtWithLoading}
          previewingProduct={previewingProduct}
          ratingValue={ratingValue}
          ratingCount={ratingCount}
        />

        <RecommendationsCard
          title={`More By ${brandName}`}
          list={moreByBrand}
          trackCategory={'More By - ' + brandName}
          className={tablet_hidden}
        />

        <RecommendationsCard
          title="You May Also Like"
          list={similarProducts}
          trackCategory={'Similar Products - ' + product.title}
          sliderSettings={{ slidesToShow: 5, slidesToScroll: 5 }}
        />

        <RecommendationsCard
          title="Often Bought With"
          list={boughtWith}
          trackCategory={'Recommendation - ' + category.name}
          sliderSettings={{ slidesToShow: 5, slidesToScroll: 5 }}
          className={moreByBrand.length ? null : tablet_hidden}
        />

        {!!product.footer_html && (
          <Card tag="section">
            <Body dangerouslySetInnerHTML={{ __html: product.footer_html }} />
          </Card>
        )}

        {!ratingsLoading &&
          ((ratings && ratings.stats && ratings.stats.count) || user) && (
            <Card tag="section" className={styles.recommendationsCard}>
              <RatingsAndReviews sku={product.sku_id} ratings={ratings} />
            </Card>
          )}

        <AsyncLeadCaptureModal />
      </MediumContainer>
    );
  }
}

function mapStateToProps(state) {
  const {
    product,
    productLoading,
    previewingProduct,
    moreByBrand,
    moreByBrandLoading,
    similarProducts,
    similarProductsLoading,
    boughtWith,
    boughtWithLoading,
    ratings,
    ratingsLoading,
    parentCategories
  } = state.product;

  const address = state.address;

  const { user } = state.login;

  return {
    product,
    productLoading,
    previewingProduct,
    moreByBrand,
    moreByBrandLoading,
    similarProducts,
    similarProductsLoading,
    boughtWith,
    boughtWithLoading,
    ratings,
    ratingsLoading,
    parentCategories,
    address,
    user
  };
}

export default connect(
  mapStateToProps,
  { ...productActions }
)(Product);
